import { Component, OnInit, Input } from "@angular/core";
import { ThemeService } from "src/app/theme.service";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { DataService } from "src/app/data.service";

@Component({
  selector: "app-home-projects",
  templateUrl: "./home-projects.component.html",
  styleUrls: ["./home-projects.component.css"],
})
export class HomeProjectsComponent implements OnInit {
  @Input() navigate;
  faInfoCircle = faInfoCircle;
  selected: any[];

  constructor(
    public themeService: ThemeService,
    public dataService: DataService
  ) {
    this.selected = dataService.project.projects.filter(
      (element) => element.selected
    );
  }

  ngOnInit(): void {}
}
